import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {deleteGrant} from 'src/openapi/admin/apis/EntitlementsGrantApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    grantId: string,
    onSuccess: () => void,
    onFail: (error: string) => void,
};

export const useRemoveGrant = ({grantId, onSuccess, onFail}: Props) => {
    const apiDispatch = useAppDispatch();

    const eventAction = useCallback((reason: string) => apiDispatch(
        deleteGrant({grantId, deleteGrantRequest: {reason}}),
    ), [grantId, apiDispatch]);

    return useCommonEventHook({
        eventAction,
        onSuccess,
        onFail,
    });
};
